function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Component, Children } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import { func, dom, events } from '../util';
import position from './utils/position';
import findNode from './utils/find-node';
var noop = func.noop;
var getStyle = dom.getStyle;
var place = position.place;

var Position = /*#__PURE__*/function (_Component) {
  _inherits(Position, _Component);

  var _super = _createSuper(Position);

  function Position() {
    var _this;

    _classCallCheck(this, Position);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      clearTimeout(_this.resizeTimeout);
      _this.resizeTimeout = setTimeout(function () {
        _this.setPosition();
      }, 200);
    });

    return _this;
  }

  _createClass(Position, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setPosition();

      if (this.props.needListenResize) {
        events.on(window, 'resize', this.handleResize);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if ('align' in nextProps && nextProps.align !== this.props.align || nextProps.shouldUpdatePosition || !this.props.visible && nextProps.visible) {
        this.shouldUpdatePosition = true;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.shouldUpdatePosition) {
        this.setPosition();
        this.shouldUpdatePosition = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.needListenResize) {
        events.off(window, 'resize', this.handleResize);
      }

      clearTimeout(this.resizeTimeout);
    }
  }, {
    key: "setPosition",
    value: function setPosition() {
      var _this$props = this.props,
          role = _this$props.role,
          align = _this$props.align,
          offset = _this$props.offset,
          visible = _this$props.visible,
          beforePosition = _this$props.beforePosition,
          onPosition = _this$props.onPosition,
          needAdjust = _this$props.needAdjust,
          rtl = _this$props.rtl;

      if (!visible) {
        return;
      }

      beforePosition();
      var contentNode = this.getContentNode();
      var targetNode = this.getTargetNode();
      var containerNode = this.getContainerNode(this.props);

      if (contentNode && targetNode) {
        var resultAlign = place({
          role: role,
          pinElement: contentNode,
          baseElement: targetNode,
          align: align,
          offset: offset,
          needAdjust: needAdjust,
          isRtl: rtl,
          containerNode: containerNode
        });
        var top = getStyle(contentNode, 'top');
        var left = getStyle(contentNode, 'left');
        onPosition({
          align: resultAlign.split(' '),
          top: top,
          left: left
        }, contentNode);
      }
    }
  }, {
    key: "getContentNode",
    value: function getContentNode() {
      return findDOMNode(this);
    }
  }, {
    key: "getContainerNode",
    value: function getContainerNode(props) {
      var targetNode = findNode(props.target);
      return findNode(props.container, targetNode);
    }
  }, {
    key: "getTargetNode",
    value: function getTargetNode() {
      var target = this.props.target;
      return target === position.VIEWPORT ? position.VIEWPORT : findNode(target, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      return Children.only(this.props.children);
    }
  }]);

  return Position;
}(Component);

_defineProperty(Position, "VIEWPORT", position.VIEWPORT);

_defineProperty(Position, "propTypes", {
  role: PropTypes.string,
  children: PropTypes.node,
  visible: PropTypes.bool,
  container: PropTypes.any,
  target: PropTypes.any,
  align: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  offset: PropTypes.array,
  beforePosition: PropTypes.func,
  onPosition: PropTypes.func,
  needAdjust: PropTypes.bool,
  needListenResize: PropTypes.bool,
  shouldUpdatePosition: PropTypes.bool,
  rtl: PropTypes.bool
});

_defineProperty(Position, "defaultProps", {
  align: 'tl bl',
  offset: [0, 0],
  beforePosition: noop,
  onPosition: noop,
  needAdjust: true,
  needListenResize: true,
  shouldUpdatePosition: false,
  rtl: false
});

export { Position as default };